<template>
  <div class="options" @mouseover="onMouseover" @mouseleave="onMouseLeave">
    <slot name="icon"/>
    <template v-if="ButtonMenuOpen">
      <div class="options__popup" v-if="archived">
        <button class="options__popup-btn" @click="onClickRepeat">Repeat</button>
        <button class="options__popup-btn" @click="onClickDelete">Delete</button>
      </div>
      <div class="options__popup" v-else>
        <button class="options__popup-btn" @click="onClickEdit">Edit</button>
        <button class="options__popup-btn" @click="onClickArchive">Archive</button>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  data: () => ({
    ButtonMenuOpen: false,
  }),
  props: {
    archived: Boolean,
  },
  methods: {
    onMouseover() {
      if (this.ButtonMenuOpen) {
        return;
      }
      this.$emit('mouseover');
      this.ButtonMenuOpen = true;
    },
    onMouseLeave() {
      this.ButtonMenuOpen = false;
    },
    onClickItem() {
      this.ButtonMenuOpen = false;
    },
    onClickEdit() {
      this.$emit('onClickEdit');
    },
    onClickRepeat() {
      this.$emit('onClickRepeat');
    },
    onClickArchive() {
      this.$emit('onClickArchive');
    },
    onClickDelete() {
      this.$emit('onClickDelete');
    },
  },
};
</script>


<style lang="scss" scoped>
  .options {
    width: 18px;
    height: 18px;
    position: relative;
    &:hover {
      max-width: 120px;
      .options__popup {
        display: block;
      }
      .icon-gear {
        z-index: 3;
      }
    }
    &__popup {
      padding-top: 60px;
      display: none;
      background: $white-color2;
      position: absolute;
      top: -21px;
      left: -81px;
      width: 120px;
      border-radius: 5px;
      box-shadow: 12px 12px 30px rgba(0, 0, 0, 0.2);
      z-index: 2;
    }
    &__popup-btn {
      @include removeBtnDefaults();
      @include font(14px, $black-color1);
      display: block;
      width: 100%;
      padding: 22px 20px;
      &:last-child {
        border-radius: 0 0 5px 5px;
      }
      &:hover {
        background: $red-color3;
        color: $white-color2;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/uikit/ButtonMenu.vue